import React, { lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import MyCourses from './pages/MyCourses';
import Modules from './pages/Modules';
import RedirectPayment from './pages/RedirectPayment';
import Order from './pages/Order';
import MyCetificate from './pages/MyCertificate';
import Auth from './pages/Auth';
import Layout from "./components/Layout";
import ScrollToTop from "./components/ScrollToTop"; // Add this import
import "./App.css";
const AuthedRoute = lazy(() => import("./AuthedRoute"));
const ControlledRoute = lazy(() => import("./ControlledRoute"));


function App() {
  return (
    <Router>
      <ScrollToTop /> {/* Add this line */}
      <Routes >
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route
            path="/login"
            element={
              <ControlledRoute>
                <Auth />
              </ControlledRoute>
            }
          />
          <Route element={<AuthedRoute />}>
            <Route path="my-courses" element={<MyCourses />} />
            <Route path="my-courses/:moduleId" element={<Modules />} />
            <Route path="redirect-payment" element={<RedirectPayment />} />
            <Route path="orders/:orderId" element={<Order />} />
            <Route path="my-certificate" element={<MyCetificate />} />
          </Route>
        </Route>

      </Routes>
    </Router>
  );
}

export default App;
